import {Preferences} from './Preferences';
import {UserLimit} from './UserLimit';
import {TypeTwoFa} from './TypeTwoFa';

export class User {

  username = '';
  type2fa: TypeTwoFa = TypeTwoFa.NONE;
  accountLocked = true;
  dateCredentialsExpire: string | null = null;
  dateLicenseExpire: string | null = null;
  acceptLicense = false;
  permissions: Array<string>;
  preferences: Preferences;
  limits: Array<UserLimit>;
  name: string | null = null;

  constructor() {
    this.permissions = [];
    this.preferences = new Preferences();
    this.limits = [];
  }

  setFromObject(obj: any): void {
    this.username = obj.username;
    this.type2fa = obj.type2fa;
    this.accountLocked = obj.accountLocked;
    this.dateCredentialsExpire = obj.dateCredentialsExpire;
    this.dateLicenseExpire = obj.dateLicenseExpire;
    this.acceptLicense = obj.acceptLicense;
    this.permissions = obj.permissions;
    this.preferences = obj.preferences;
    this.limits = obj.limits;
    this.name = obj.name;
  }

  getLimit(type: string): UserLimit {
    const userLimit = this.limits.filter(limit => limit.name && limit.name === type).pop();
    return userLimit ? userLimit : new UserLimit();
  }

}
